import { useState, useEffect } from "react";
import { selectCurrentUser, selectUsers } from "src/modules/users/selector";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import {
  selectItems
} from "src/modules/spItems/selectors";
import { ArrowDown, Comment } from "src/components/ui-icons/card";
import _ from "lodash";
import HistoryStatuses from "../historyStatuses";
import HistoryFieldChanges from "../historyFieldChanges";
import PeoplePicker from "src/components/ui/form/peoplePicker";
import Button from "src/components/Button";
import Loading from "src/components/Loading";
import { UserAvatar } from "src/components/ui/avatar/Avatar";
import { addItemRequest, deleteItemRequest, getItemsRequest, updateItemRequest } from "src/modules/spItems/api";
import moment from "moment";
import {
  approversCardDocumentListName,
  approversDependenciesListName,
  emailsSender,
  historyByDocumentListName,
  historyChangeFieldsDocumentListName,
  paramsListName,
  siteUrl
} from "src/api/config";
import { emailAPI } from "src/utils/api.utils";
import { addUsers } from "src/modules/users/actions";
import { notificationsListName } from "src/api/config/notifications.config";
import { RootState } from "src/store/rootReducer";
import { emailQueueListName } from "src/api/config/email.config";
import { docStatuses, notificationStatuses } from "src/api/config/systemSwitch";
import { FlexCol } from "src/utils/flexLayouts";
import { TooltipItem } from "src/utils/Tooltip";
const { sendEmail } = emailAPI();

export const getLatestUniqueGroups = (arr: any) => {
  const map = new Map();

  for (const item of arr) {
    const key = ((item.ApprovalGroup && item.ApprovalGroup.ID) || (item.ApprovalGroup && item.ApprovalGroup.get_lookupId())); // или комбинированный ключ, если нужно

    if (key) {
      const existing = map.get(key);

      if (!existing || new Date(item.Created) > new Date(existing.Created)) {
        map.set(key, item);
      }
    }
  }
  return [...map.values()];
};

type Props = {
  versionView: any;
  documentCardID: any;
  card: any;
  approversList: any;
};

const ApproversCard = (props: Props) => {
  const { versionView, documentCardID, card, approversList } = props;
  const [historyCard, setHistoryCard] = useState<any>([]);
  const [approversByDocument, setApproversByDocument] = useState<any>([]);
  const users: any = useAppSelector(selectUsers);
  const dispatch = useAppDispatch();
  const [edit, setEdit] = useState(false);
  const [currentApprovers, setCurrentApprovers] = useState<any>({});
  const [newApprovers, setNewApprovers] = useState<any>({});
  const currentUser = useAppSelector(selectCurrentUser);
  const [showSaveBtns, setShowSaveBtns] = useState(false);
  const [customLoading, setCustomLoading] = useState(true);
  const [approversDependencies, setApproversDependencies] = useState<any>([]);
  const repeatEmails: any = useAppSelector((state) => selectItems(state, paramsListName));
  const statusUsers: string = useAppSelector((state: RootState) => state.users.status);
  const [renderHistoryData, setRenderHistoryData] = useState<any>([]);
  const [reRender, setReRender] = useState(false);

  /*useEffect(() => {
    console.log(" --- renderHistoryData: ", renderHistoryData);
    console.log(" --- historyCard: ", historyCard);
    console.log(" --- approversByDocument: ", approversByDocument);
  }, [renderHistoryData, historyCard, approversByDocument]);*/

  useEffect(() => {
    console.log(" --- renderHistoryData: ", renderHistoryData);
    console.log(" --- historyCard: ", historyCard);
    console.log(" --- approversByDocument: ", approversByDocument);
  }, [renderHistoryData, historyCard, approversByDocument]);

  useEffect(() => {
    if (card) {
      getItemsRequest({ listName: historyByDocumentListName, filters: { DocumentID: versionView || documentCardID, VersionDocument: versionView && true || false }, sortOrder: { name: "ID", asc: true } }).then((results) => {
        setHistoryCard(getLatestUniqueGroups([...results.items]));
        getItemsRequest({ listName: approversCardDocumentListName, filters: { Document: card.ID, VersionDocument: versionView && true || false } }).then((result) => {
          setApproversByDocument([...result.items]);
          getItemsRequest({
            listName: approversDependenciesListName,
            filters: { DocType: card.DocType.get_lookupId(), Collection: card.Collection.get_lookupId() },
            sortOrder: { name: "Order0", asc: true },
          }).then((results: any) => {
            if (results.items.length > 0) {
              let usersEmail: any = [];
              // @ts-ignore
              results.items.forEach((item: any) => {
                Object.keys(item).forEach((key) => {
                  const field = item[key];
                  if (field && !Array.isArray(field) && field.get_email) {
                    if (field.get_email()) {
                      usersEmail = [...usersEmail, field.get_email().toLowerCase()];
                    }
                  }
                  if (
                    field &&
                    Array.isArray(field) &&
                    field.length > 0 &&
                    field[0].get_email
                  ) {
                    field.forEach((user) => {
                      if (user.get_email()) {
                        usersEmail = [
                          ...usersEmail,
                          user.get_email().toLowerCase(),
                        ];
                      }
                    });
                  }
                });
              });
              usersEmail = _.uniqWith(usersEmail, _.isEqual);
              if (usersEmail.length > 0) {
                let actualEmails: any = [];
                usersEmail.forEach((item: string) => {
                  let check = false;
                  Object.keys(users).forEach((key) => {
                    if (key === item) {
                      check = true;
                    }
                  });
                  if (!check) {
                    actualEmails = [...actualEmails, item.toLowerCase()];
                  }
                });
                if (actualEmails) {
                  dispatch(addUsers(actualEmails));
                }
              }
            }
            setApproversDependencies([...results.items]);
            setCustomLoading(false);
          });
        });
      })
    }
  }, [card, reRender]);

  useEffect(() => {
    if (
      card &&
      card.Status.get_lookupId() === docStatuses.approval &&
      approversByDocument.length > 0 &&
      historyCard.length > 0
    ) {
      //Изменение согласующих доступно авторам, согласовантам и админам при статусе документа "На согласовании"
      if (
        currentUser.isAdmin ||
        (currentUser.email &&
          currentUser.email.toLowerCase() === card.AuthorEmail.toLowerCase())
      ) {
        setEdit(true);
      } else {
        let flagEdit = false;
        approversByDocument.forEach((element: any) => {
          if (
            element.Approvers.some(
              (item: any) =>
                item.get_email().toLowerCase() === currentUser.email.toLowerCase()
            )
          ) {
            flagEdit = true;
          }
        });
        if (flagEdit) {
          setEdit(true);
        } else {
          setEdit(false);
        }
      }
    }
  }, [card, currentUser, approversByDocument, historyCard]);

  useEffect(() => {
    if (Object.keys(newApprovers).length > 0) {
      setShowSaveBtns(true);
    }
  }, [newApprovers]);

  const changesApproversHandle = (approvers: []) => {
    if (approvers && approvers.length > 0) {
      let objApprovers: any = {};
      approvers.forEach((approver: any) => {
        if (!objApprovers.hasOwnProperty(approver.code)) {
          objApprovers[approver.code] = [];
        }
        objApprovers[approver.code] = [
          ...objApprovers[approver.code],
          approver,
        ];
      });
      Object.keys(objApprovers).map((key: string) => {
        setNewApprovers((prevState: any) => {
          return {
            ...prevState,
            [key]: approvers,
          };
        });
      });
    }
  };

  useEffect(() => {
    if (
      card &&
      approversDependencies.length > 0 &&
      historyCard.length > 0
    ) {
      historyCard.map((history: any) => {
        if (
          history.Statuses.filter(
            (status: any) => status.get_lookupId() === docStatuses.waitApproval
          ).length === 1
        ) {
          const approversRowDependencies: any = _.orderBy(
            approversDependencies,
            ["Order0"],
            ["asc"]
          ).filter(
            (approvers: any) => history.ApprovalGroup && approvers.Group.get_lookupId() === history.ApprovalGroup.get_lookupId()
          )[0];
          setCurrentApprovers((prevState: any) => {
            return {
              ...prevState,
              [history.ApprovalGroup && history.ApprovalGroup.get_lookupId()]: {
                field: {
                  dataField: {
                    single: false,
                    options:
                      approversRowDependencies &&
                      approversRowDependencies.Users.length > 0 &&
                      approversRowDependencies.Users.map((item: any) => {
                        const email = item.get_email().toLowerCase();
                        return {
                          value: users[email] && users[email].email,
                          label: users[email] && users[email].displayName,
                          avatar: users[email] && users[email].avatar,
                          email: users[email] && users[email].email,
                          code: history.ApprovalGroup.get_lookupId(),
                        };
                      }) || [],
                    disabled:
                      approversRowDependencies &&
                      approversRowDependencies.NotChange,
                    width: "w-full",
                    placeholder: "Введите имя или фамилию",
                  },
                  onChange: changesApproversHandle,
                  value:
                    (approversRowDependencies &&
                      approversRowDependencies.NotChange &&
                      approversRowDependencies.DefaultApprovers &&
                      approversRowDependencies.DefaultApprovers.length > 0 &&
                      approversRowDependencies.DefaultApprovers.map(
                        (item: any) => {
                          const email = item.get_email().toLowerCase();
                          return {
                            value: users[email] && users[email].email,
                            label: users[email] && users[email].displayName,
                            avatar: users[email] && users[email].avatar,
                            email: users[email] && users[email].email,
                            code: history.ApprovalGroup.get_lookupId(),
                          };
                        }
                      )) ||
                    (history.Approvers &&
                      history.Approvers.map((item: any) => {
                        return {
                          value: users[item.get_email()] && users[item.get_email()].email,
                          label:
                            users[item.get_email()] && users[item.get_email()].displayName,
                          avatar: users[item.get_email()] && users[item.get_email()].avatar,
                          email: users[item.get_email()] && users[item.get_email()].email,
                          code: history.ApprovalGroup.get_lookupId(),
                        };
                      })) ||
                    [],
                  type: "history",
                },
              },
            };
          });
        }
      });
    }
  }, [historyCard, approversDependencies, card, users]);

  const resetDefaultValuesHandle = () => {
    setNewApprovers({});
    setCurrentApprovers({});
    setApproversDependencies([]);
    setShowSaveBtns(false);
  };

  const saveNewApproversHandle = () => {
    let updateHistory: any = [],
      updateApprovers: any = [],
      dataNotificationCard: any = [],
      oldApproversForHistory: any = [],
      newApproversForHistory: any = [],
      newApproversTemp: any = { ...newApprovers };
    setCustomLoading(true);
    historyCard.forEach((history: any) => {
      if (
        history.Statuses.filter(
          (status: any) => status.get_lookupId() === docStatuses.waitApproval
        ).length === 1
      ) {
        if (
          newApproversTemp[history.ApprovalGroup.get_lookupId()] &&
          Array.isArray(newApproversTemp[history.ApprovalGroup.get_lookupId()]) &&
          newApproversTemp[history.ApprovalGroup.get_lookupId()].length > 0
        ) {
          oldApproversForHistory = [
            ...oldApproversForHistory,
            ...history.Approvers.map((user: any) =>
              user.get_email().toLowerCase().trim()
            ),
          ];
          newApproversForHistory = [
            ...newApproversForHistory,
            ...newApproversTemp[history.ApprovalGroup.get_lookupId()].map(
              (user: any) => user.value
            ),
          ];
          updateHistory = [
            ...updateHistory,
            {
              ID: history.ID,
              Approvers: newApproversTemp[history.ApprovalGroup.get_lookupId()].map(
                (user: any) => user.value
              ),
            },
          ];
        }
      }
    });
    let requests: any = [];
    if (updateHistory.length > 0) {
      requests = [...requests, updateItemRequest({ listName: historyByDocumentListName, body: updateHistory[0], bodyArr: updateHistory })];
    }

    const changesFieldValue = {
      ApproverChange: {
        old: oldApproversForHistory,
        new: newApproversForHistory,
      },
    };

    const historyFieldsCardAdd = {
      Title: `History fields card # ${card.ID}`,
      DocumentID: card.ID,
      JSONChangesFields: JSON.stringify(changesFieldValue),
      Statuses: [docStatuses.edited], // Изменён
      VersionDocument: (versionView && true) || false,
    };
    requests = [...requests, addItemRequest({ listName: historyChangeFieldsDocumentListName, body: historyFieldsCardAdd })];

    approversByDocument.forEach((approvers: any) => {
      if (
        approvers.Statuses.filter(
          (status: any) => status.get_lookupId() === docStatuses.waitApproval
        ).length === 1
      ) {
        if (
          newApproversTemp[approvers.Group.get_lookupId()] &&
          Array.isArray(newApproversTemp[approvers.Group.get_lookupId()]) &&
          newApproversTemp[approvers.Group.get_lookupId()].length > 0
        ) {
          if (approvers.Queue) {
            newApproversTemp[approvers.Group.get_lookupId()]
              .map((user: any) => user.value)
              .forEach((email: any) => {
                dataNotificationCard = [
                  ...dataNotificationCard,
                  {
                    Title:
                      (versionView && `Согласовать версию # ${card.ID}`) ||
                      `Согласовать # ${card.ID}`,
                    ReviewDate: moment(new Date())
                      .add(
                        Number(
                          repeatEmails
                            .find(
                              (param: any) =>
                                param.Key === "documentsApproveDays"
                            )
                          ["Value"].trim()
                        ),
                        "days"
                      )
                      .toDate(),
                    AuthorComment: "",
                    DocumentCode: `${card.Code}.${card.Index}`,
                    Document: (versionView && card.MainDocument.ID) || card.ID,
                    NotificationType: notificationStatuses.approval, // Согласовать
                    Employee: email.toLowerCase(),
                    VersionDocument: versionView,
                    EmployeeEmail: email.toLowerCase(),
                    AuthorEmail: currentUser.email.toLowerCase(),
                    Completed: new Date(),
                  },
                ];
              });
            if (emailsSender) {
              requests = [...requests, getItemsRequest({
                listName: emailQueueListName,
                filters: {
                  CheckDoc:
                    (versionView && String(card.MainDocument.ID)) ||
                    String(card.ID),
                },
              }).then((results) => {
                const emails = [...results.items];
                const emailsIDs: { ID: number }[] = emails.map((email) => {
                  return { ID: email.ID };
                });
                deleteItemRequest({
                  listName: emailQueueListName,
                  Ids: emailsIDs,
                  ID: 0,
                })
              })]
              let emailsHanleArr: any = [];
              const minutes = Number(
                repeatEmails
                  .find((param: any) => param.Key === "documentApprove")
                ["Value"].trim()
              );
              const dateSendEmailsArr = [
                moment(new Date()).clone().subtract(12, "hours").toDate(),
                moment(new Date()).clone().add(minutes, "m").toDate(),
              ];
              dateSendEmailsArr.forEach((date: Date, idxDate: number) => {
                newApproversTemp[approvers.Group.get_lookupId()]
                  .map((user: any) => user.value)
                  .forEach((email: any) => {
                    const emailBody = {
                      Body: `Здравствуйте ${users[email.toLowerCase()] &&
                        users[email.toLowerCase()]["displayName"]
                        },<br/><br/>Прочитайте следующий документ и подтвердите факт его согласования:<br/><br/><a href="${siteUrl}/dashboard/1?documentCard=${(versionView && card.MainDocument.ID) || card.ID
                        }${(versionView && `&version=${versionView}`) || ""
                        }">${card.Title
                        }</a><br/><br/>Срок согласования: <span${(idxDate === 1 && ` style="color:red;"`) || ""
                        }>${moment(new Date())
                          .add(
                            Number(
                              repeatEmails
                                .find(
                                  (param: any) =>
                                    param.Key === "documentsApproveDays"
                                )
                              ["Value"].trim()
                            ),
                            "days"
                          )
                          .format("DD.MM.YYYY")}</span>`,
                      DateToBeSentAt: date,
                      Title: "Мои Документы | Согласование документа",
                      Subject: "Мои Документы | Согласование документа",
                      Recepients: email,
                      CheckDoc:
                        (versionView && String(card.MainDocument.ID)) ||
                        String(card.ID),
                      RepeatAt: (idxDate === 1 && minutes) || 0,
                    };
                    emailsHanleArr = [
                      ...emailsHanleArr,
                      sendEmail(emailBody),
                    ];
                  });
              });
              requests = [...requests, ...emailsHanleArr];
            }
          }
          updateApprovers = [
            ...updateApprovers,
            {
              ID: approvers.ID,
              Approvers: newApproversTemp[approvers.Group.get_lookupId()].map(
                (user: any) => user.value
              ),
            },
          ];
        }
      }
    });
    if (updateApprovers.length > 0) {
      requests = [...requests, updateItemRequest({ listName: approversCardDocumentListName, body: updateApprovers[0], bodyArr: updateApprovers })];
    }
    if (dataNotificationCard.length > 0) {
      requests = [...requests, addItemRequest({ listName: notificationsListName, body: dataNotificationCard[0], bodyArr: dataNotificationCard })];
    }
    Promise.all(requests).then(() => {
      setNewApprovers({});
      setCurrentApprovers({});
      setApproversDependencies([]);
      setShowSaveBtns(false);
      setCustomLoading(false);
      setReRender(!reRender);
    });
  };

  useEffect(() => {
    // 1. Сортируем даты отдельно
    const sortedDates = [...historyCard]
      .map((item: any) => item.Created)
      .sort(
        (a: string, b: string) =>
          new Date(a).getTime() - new Date(b).getTime()
      );

    // 2. Сортируем элементы по order
    const tempHistoryCardUpdateOrder = historyCard
      .map((item: any) => {
        const group = approversDependencies.find(
          (group: any) =>
            group.Group?.get_lookupId?.() ===
            item.ApprovalGroup?.get_lookupId?.()
        );

        return {
          ...item,
          order: group?.Order0 ?? 0,
        };
      })
      .sort((a: any, b: any) => a.order - b.order)
      .map((item: any, index: number) => ({
        ...item,
        // 3. Подставляем даты по порядку
        Created: sortedDates[index],
      }));

    // 4. Добавляем MultiApprove
    const resultWithMultiApprove = tempHistoryCardUpdateOrder.map((historyItem) => {
      const historyGroupId = historyItem.ApprovalGroup?.get_lookupId?.();
      const matchingDependency = approversDependencies.find(
        (dependency) => dependency.Group?.get_lookupId?.() === historyGroupId
      );
      const multiApproveValue = matchingDependency ? matchingDependency.MultiApprove === true : false;
      // Находим соответствующую запись в approversByDocument для получения MultiApproved
      const matchingApproversRecord = approversByDocument.find(
        (approverRecord: any) =>
          approverRecord.Group?.get_lookupId?.() === historyGroupId
      );

      const multiApprovedUsers = matchingApproversRecord?.MultiApproved || [];
      return {
        ...historyItem,
        MultiApprove: multiApproveValue,
        MultiApproved: multiApprovedUsers,
      };
    });

    //setRenderHistoryData(tempHistoryCardUpdateOrder);
    setRenderHistoryData(resultWithMultiApprove);
  }, [historyCard, approversDependencies]);

  useEffect(() => {
    console.log(" --- approversDependencies: ", approversDependencies);
  }, [approversDependencies]);

  useEffect(() => {
    console.log(" --- renderHistoryData: ", renderHistoryData);
  }, [renderHistoryData]);

  return (
    <div className="flex-1 bg-white rounded-lg shadow-xl">
      {((customLoading || statusUsers === "LOADING") && <FlexCol className="items-center justify-center w-full">
        <span className="block mb-5 text-base text-darkblue">
          Идет обработка данных.
          <br />
          Пожалуйста подождите...
        </span>
        <Loading />
      </FlexCol>) || (
          <>
            <div className="relative px-4">
              {(((card.Status.get_lookupId() === docStatuses.public ||
                card.Status.get_lookupId() === docStatuses.review) &&
                historyCard.filter((history: any) => history.Approved).length > 1) ||
                (card.Status.get_lookupId() !== docStatuses.public &&
                  card.Status.get_lookupId() !== docStatuses.review &&
                  historyCard.length > 1)) && (
                  <div className="absolute left-[14.5px] h-full border border-solid border-[#DFE4EA]"></div>
                )}
              {((card.Status.get_lookupId() === docStatuses.public ||
                card.Status.get_lookupId() === docStatuses.review) && (
                  <>
                    {renderHistoryData.length > 0 &&
                      renderHistoryData.map(
                        (history: any) => (
                          <>
                            {history.Approved && (
                              <div className="history_block flex w-full my-6 -ml-1.5">
                                <div className="pt-5 flex items-start w-2/12 z-10">
                                  <div className="w-2.5 h-2.5 bg-[#DFE4EA] rounded-full mr-4 mt-1.5"></div>
                                  <span className="text-[#637381] text-sm">
                                    {moment(history.Created).format("HH:mm DD.MM.YYYY")}
                                  </span>
                                </div>
                                <div className="flex p-5 flex-col justify-center items-start gap-5 flex-[1_0%_0%] w-9/12 rounded-lg border border-solid border-[#DFE4EA]">
                                  <div className="w-full items-center flex justify-between">
                                    <span className="text-sm">
                                      {(history.ChangeRights && history.Title) ||
                                        history.ApprovalGroup.get_lookupValue()}
                                    </span>
                                    <HistoryStatuses statuses={history.Statuses} />
                                  </div>
                                  <div className={`flex items-left gap-2 w-full ${history.MultiApprove && "no-wrap flex-col"}`}>
                                    {!history.MultiApprove &&
                                      <>
                                        <UserAvatar
                                          avatar={
                                            users[history.Approved.get_email()] &&
                                            users[history.Approved.get_email()].avatar
                                          }
                                          shortName={
                                            users[history.Approved.get_email()] &&
                                            users[history.Approved.get_email()]
                                              .displayName &&
                                            users[
                                              history.Approved.get_email()
                                            ].displayName.split(" ")[0][0] +
                                            users[
                                              history.Approved.get_email()
                                            ].displayName.split(" ")[1][0]
                                          }
                                          displayName={
                                            users[history.Approved.get_email()] &&
                                            users[history.Approved.get_email()].displayName
                                          }
                                          email={history.Approved.get_email()}
                                        />
                                        <div className="flex flex-col justify-center items-start">
                                          <span className="text-sm text-[#111928]">
                                            {users[history.Approved.get_email()] &&
                                            users[history.Approved.get_email()]
                                              .displayName}
                                          </span>
                                          <span
                                            className="text-sm text-[#637381]"
                                            dangerouslySetInnerHTML={{
                                            __html:
                                              users[history.Approved.get_email()] &&
                                              users[history.Approved.get_email()][
                                              "jobTitle"
                                              ],
                                          }}
                                          />
                                        </div>
                                      </>
                                    }
                                    {history.MultiApprove && (
                                      <>
                                        {history.Approved && history.Approvers.map((approver: any) => (
                                          <div className="flex gap-0.5">
                                            <UserAvatar
                                              avatar={
                                                users[approver.get_email()] &&
                                                users[approver.get_email()].avatar
                                              }
                                              shortName={
                                                users[approver.get_email()] &&
                                                users[approver.get_email()]
                                                  .displayName &&
                                                users[
                                                  approver.get_email()
                                                ].displayName.split(" ")[0][0] +
                                                users[
                                                  approver.get_email()
                                                ].displayName.split(" ")[1][0]
                                              }
                                              displayName={
                                                users[approver.get_email()] &&
                                                users[approver.get_email()].displayName
                                              }
                                              email={approver.get_email()}
                                            />
                                            <div className="flex flex-col justify-center items-start">
                                              <span className="text-sm text-[#111928]">
                                                {users[approver.get_email()] &&
                                                users[approver.get_email()]
                                                  .displayName}
                                                <TooltipItem position="top-center" className="w-max" tooltipsText="Согласован">
                                                  <div className="flex items-center flex-col">
                                                    <svg className="inline-block -mt-1 ml-1.5" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                      <path d="M11.225 11.8199C11.225 12.0699 11.025 12.2699 10.775 12.2699H1.575C1.325 12.2699 1.125 12.0699 1.125 11.8199V2.61992C1.125 2.36992 1.325 2.16992 1.575 2.16992H9.925L10.925 1.04492C10.875 1.04492 10.85 1.04492 10.8 1.04492H1.575C0.725 1.04492 0 1.74492 0 2.61992V11.8449C0 12.7199 0.7 13.4199 1.575 13.4199H10.8C11.65 13.4199 12.375 12.7199 12.375 11.8449V2.84492L11.25 4.09492V11.8199H11.225Z" fill="#22AD5C"/>
                                                      <path d="M13.2501 0.144272C13.0251 -0.0557281 12.6751 -0.0557281 12.4501 0.194272L11.5251 1.21927L10.6751 2.16927L5.90014 7.51927L3.52514 5.34427C3.30014 5.14427 2.95014 5.14427 2.72514 5.36927C2.52514 5.59427 2.52514 5.94427 2.75014 6.16927L5.55014 8.71927C5.65014 8.81927 5.80014 8.86927 5.92514 8.86927H5.95014C6.10014 8.86927 6.25014 8.79427 6.35014 8.69427L11.2251 3.24427L12.2501 2.09427L13.3001 0.919272C13.5001 0.694272 13.5001 0.344272 13.2501 0.144272Z" fill="#22AD5C"/>
                                                    </svg>
                                                  </div>
                                                </TooltipItem>

                                              </span>
                                              <span
                                                className="text-sm text-[#637381]"
                                                dangerouslySetInnerHTML={{
                                                __html:
                                                  users[approver.get_email()] &&
                                                  users[approver.get_email()][
                                                  "jobTitle"
                                                  ],
                                                }}
                                              />
                                            </div>
                                          </div>
                                        ))}
                                        {history.Denied && (
                                          <>
                                            {history.MultiApproved && history.MultiApproved.length > 0 && history.MultiApproved.map((approver: any) => (
                                              <div className="flex gap-0.5">
                                                <UserAvatar
                                                  avatar={
                                                      users[approver.get_email()] &&
                                                      users[approver.get_email()].avatar
                                                    }
                                                  shortName={
                                                      users[approver.get_email()] &&
                                                      users[approver.get_email()]
                                                        .displayName &&
                                                      users[
                                                        approver.get_email()
                                                      ].displayName.split(" ")[0][0] +
                                                      users[
                                                        approver.get_email()
                                                      ].displayName.split(" ")[1][0]
                                                    }
                                                  displayName={
                                                      users[approver.get_email()] &&
                                                      users[approver.get_email()].displayName
                                                    }
                                                  email={approver.get_email()}
                                                />
                                                <div className="flex flex-col justify-center items-start">
                                                    <span className="text-sm text-[#111928]">
                                                      {users[approver.get_email()] &&
                                                      users[approver.get_email()]
                                                        .displayName}
                                                      <TooltipItem position="top-center" className="w-max" tooltipsText="Согласован">
                                                        <div className="flex items-center flex-col">
                                                          <svg className="inline-block -mt-1 ml-1.5" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M11.225 11.8199C11.225 12.0699 11.025 12.2699 10.775 12.2699H1.575C1.325 12.2699 1.125 12.0699 1.125 11.8199V2.61992C1.125 2.36992 1.325 2.16992 1.575 2.16992H9.925L10.925 1.04492C10.875 1.04492 10.85 1.04492 10.8 1.04492H1.575C0.725 1.04492 0 1.74492 0 2.61992V11.8449C0 12.7199 0.7 13.4199 1.575 13.4199H10.8C11.65 13.4199 12.375 12.7199 12.375 11.8449V2.84492L11.25 4.09492V11.8199H11.225Z" fill="#22AD5C"/>
                                                            <path d="M13.2501 0.144272C13.0251 -0.0557281 12.6751 -0.0557281 12.4501 0.194272L11.5251 1.21927L10.6751 2.16927L5.90014 7.51927L3.52514 5.34427C3.30014 5.14427 2.95014 5.14427 2.72514 5.36927C2.52514 5.59427 2.52514 5.94427 2.75014 6.16927L5.55014 8.71927C5.65014 8.81927 5.80014 8.86927 5.92514 8.86927H5.95014C6.10014 8.86927 6.25014 8.79427 6.35014 8.69427L11.2251 3.24427L12.2501 2.09427L13.3001 0.919272C13.5001 0.694272 13.5001 0.344272 13.2501 0.144272Z" fill="#22AD5C"/>
                                                          </svg>
                                                        </div>
                                                      </TooltipItem>
                                                    </span>
                                                  <span
                                                    className="text-sm text-[#637381]"
                                                    dangerouslySetInnerHTML={{
                                                      __html:
                                                        users[approver.get_email()] &&
                                                        users[approver.get_email()][
                                                        "jobTitle"
                                                        ],
                                                      }}
                                                  />
                                                </div>
                                              </div>
                                            ))}
                                            <UserAvatar
                                              avatar={
                                              users[history.Denied.get_email()] &&
                                              users[history.Denied.get_email()].avatar
                                            }
                                              shortName={
                                              users[history.Denied.get_email()] &&
                                              users[history.Denied.get_email()]
                                                .displayName &&
                                              users[
                                                history.Denied.get_email()
                                              ].displayName.split(" ")[0][0] +
                                              users[
                                                history.Denied.get_email()
                                              ].displayName.split(" ")[1][0]
                                            }
                                              displayName={
                                              users[history.Denied.get_email()] &&
                                              users[history.Denied.get_email()].displayName
                                            }
                                              email={history.Denied.get_email()}
                                            />
                                            <div className="flex flex-col justify-center items-start">
                                              <span className="text-sm text-[#111928]">
                                                {users[history.Denied.get_email()] &&
                                                users[history.Denied.get_email()]
                                                  .displayName}
                                                <TooltipItem position="top-center" className="w-max" tooltipsText="Отклонен">
                                                  <div className="flex items-center flex-col">
                                                    <svg className="inline-block -mt-1 ml-1.5" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                      <path d="M7.55 0C3.375 0 0 3.375 0 7.55C0 11.725 3.375 15.125 7.55 15.125C11.725 15.125 15.125 11.725 15.125 7.55C15.125 3.375 11.725 0 7.55 0ZM7.55 14C4 14 1.125 11.1 1.125 7.55C1.125 4 4 1.125 7.55 1.125C11.1 1.125 14 4.025 14 7.575C14 11.1 11.1 14 7.55 14Z" fill="#BA0C2F"/>
                                                      <path d="M9.85039 5.22539C9.62539 5.00039 9.27539 5.00039 9.05039 5.22539L7.55039 6.75039L6.02539 5.22539C5.80039 5.00039 5.45039 5.00039 5.22539 5.22539C5.00039 5.45039 5.00039 5.80039 5.22539 6.02539L6.75039 7.55039L5.22539 9.07539C5.00039 9.30039 5.00039 9.65039 5.22539 9.87539C5.32539 9.97539 5.47539 10.0504 5.62539 10.0504C5.77539 10.0504 5.92539 10.0004 6.02539 9.87539L7.55039 8.35039L9.07539 9.87539C9.17539 9.97539 9.32539 10.0504 9.47539 10.0504C9.62539 10.0504 9.77539 10.0004 9.87539 9.87539C10.1004 9.65039 10.1004 9.30039 9.87539 9.07539L8.35039 7.55039L9.87539 6.02539C10.0754 5.80039 10.0754 5.45039 9.85039 5.22539Z" fill="#BA0C2F"/>
                                                    </svg>
                                                  </div>
                                                </TooltipItem>
                                              </span>
                                              <span
                                                className="text-sm text-[#637381]"
                                                dangerouslySetInnerHTML={{
                                                  __html:
                                                    users[history.Denied.get_email()] &&
                                                    users[history.Denied.get_email()][
                                                    "jobTitle"
                                                  ],
                                                }}
                                              />
                                            </div>
                                          </>
                                        )}
                                      </>
                                    )}
                                    {history.ChangeRights && history.Approvers && history.Approvers.length &&
                                      <TooltipItem position="top-left" className="w-max" tooltipsReactNode={
                                        <div className="flex flex-col gap-2">
                                          {[...[history.ChangeRights], ...history.Approvers].map((approver: any) => (
                                            <div className="flex items-center gap-2 relative">
                                              {users[approver.get_email()] && users[approver.get_email()].avatar && <img className="w-6 h-6 rounded-full max-sm:h-6 max-sm:w-6" src={users[approver.get_email()].avatar} /> || <div className="flex items-center justify-center w-6 h-6 rounded-full max-sm:h-6 max-sm:w-6 bg-darkblue">
                                                <span className="font-medium text-[12px] max-sm:text-[10px] text-white select-none">{users[approver.get_email()] && users[approver.get_email()].shortName}</span>
                                              </div>}
                                              <div className="flex flex-col justify-center items-start">
                                                <span className="text-sm text-[#111928]">{users[approver.get_email()] && users[approver.get_email()].displayName}</span>
                                              </div>
                                              {history.Approvers.some((prevApprover: any) => prevApprover.get_email() === approver.get_email()) && <div className="bg-white/[.75] absolute w-full h-full"></div>}
                                            </div>
                                          ))}
                                        </div>
                                      } tooltipsText="">
                                        <div className="flex items-center flex-col">
                                          <ArrowDown />
                                        </div>
                                      </TooltipItem>
                                    }
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        )
                      )}
                  </>
                )) || (
                  <>
                    {renderHistoryData.length > 0 &&
                      renderHistoryData
                        .filter((history: any) =>
                          history.Statuses.some(
                            (item: any) => item.get_lookupId() !== docStatuses.waitApproval
                          )
                        )
                        .sort(
                          (a: any, b: any) => moment(a.Created).unix() - moment(b.Created).unix()
                        )
                        .map((history: any) => (
                          <div className="history_block flex w-full my-6 -ml-1.5">
                            <div className="pt-5 flex items-start w-2/12 z-10">
                              <div className="w-2.5 h-2.5 bg-[#DFE4EA] rounded-full mr-4 mt-1.5"></div>
                              <span className="text-[#637381] text-sm">
                                {moment(history.Created).format("HH:mm DD.MM.YYYY")}
                              </span>
                            </div>
                            <div className="flex p-5 flex-col justify-center items-start gap-5 flex-[1_0%_0%] w-9/12 rounded-lg border border-solid border-[#DFE4EA]">
                              <div className="w-full items-center flex justify-between">
                                <span className="text-sm">
                                  {(history.ChangeRights && history.Title) ||
                                    history.ApprovalGroup.get_lookupValue()}
                                </span>
                                <HistoryStatuses statuses={history.Statuses} />
                              </div>
                              <div className={`flex items-left gap-2 w-full${history.MultiApprove && " flex-col" || " flex-row"}`}>
                                {(!history.Approved &&
                                  !history.Denied &&
                                  currentApprovers[history.ApprovalGroup.get_lookupId()] &&
                                  edit &&
                                  history.Statuses.filter(
                                    (status: any) =>
                                      status.get_lookupId() === docStatuses.waitApproval
                                  ).length === 1 && (
                                    <>
                                      {history.Approvers.map(
                                        (approver: any, idx: number) => (
                                          <>
                                            {idx === 0 && (
                                              <PeoplePicker
                                                dataField={
                                                  currentApprovers[
                                                  history.ApprovalGroup.get_lookupId()
                                                  ]["field"]["dataField"]
                                                }
                                                onChange={
                                                  currentApprovers[
                                                  history.ApprovalGroup.get_lookupId()
                                                  ]["field"]["onChange"]
                                                }
                                                value={
                                                  currentApprovers[
                                                  history.ApprovalGroup.get_lookupId()
                                                  ]["field"]["value"]
                                                }
                                                type={
                                                  currentApprovers[
                                                  history.ApprovalGroup.get_lookupId()
                                                  ]["field"]["type"]
                                                }
                                              />
                                            )}
                                          </>
                                        )
                                      )}
                                    </>
                                  )) ||
                                  (history.Approved && (
                                    <>
                                    {!history.MultiApprove && (
                                      <>
                                        <UserAvatar
                                          avatar={
                                            users[history.Approved.get_email()] &&
                                            users[history.Approved.get_email()].avatar
                                          }
                                          shortName={
                                            users[history.Approved.get_email()] &&
                                            users[history.Approved.get_email()]
                                              .displayName &&
                                            users[
                                              history.Approved.get_email()
                                            ].displayName.split(" ")[0][0] +
                                            users[
                                              history.Approved.get_email()
                                            ].displayName.split(" ")[1][0]
                                          }
                                          displayName={
                                            users[history.Approved.get_email()] &&
                                            users[history.Approved.get_email()]
                                              .displayName
                                          }
                                          email={history.Approved.get_email()}
                                        />
                                          <div className="flex flex-col justify-center items-start">
                                            <span className="text-sm text-[#111928]">
                                              {users[history.Approved.get_email()] &&
                                              users[history.Approved.get_email()]
                                                .displayName}
                                            </span>
                                            <span
                                              className="text-sm text-[#637381]"
                                              dangerouslySetInnerHTML={{
                                              __html:
                                                users[history.Approved.get_email()] &&
                                                users[history.Approved.get_email()][
                                                "jobTitle"
                                                ],
                                            }}
                                            />
                                          </div>
                                        </>
                                      )}
                                      {history.MultiApprove && (
                                        <>
                                          {history.Approved && history.Approvers.map((approver: any) => (
                                            <div className="flex flex-row gap-0.5">
                                              <UserAvatar
                                                avatar={
                                                  users[approver.get_email()] &&
                                                  users[approver.get_email()].avatar
                                                }
                                                shortName={
                                                  users[approver.get_email()] &&
                                                  users[approver.get_email()]
                                                    .displayName &&
                                                  users[
                                                    approver.get_email()
                                                  ].displayName.split(" ")[0][0] +
                                                  users[
                                                    approver.get_email()
                                                  ].displayName.split(" ")[1][0]
                                                }
                                                displayName={
                                                  users[approver.get_email()] &&
                                                  users[approver.get_email()].displayName
                                                }
                                                email={approver.get_email()}
                                              />
                                              <div className="flex flex-col justify-center items-start">
                                                <span className="text-sm text-[#111928]">
                                                  {users[approver.get_email()] &&
                                                  users[approver.get_email()]
                                                    .displayName}
                                                  <TooltipItem position="top-center" className="w-max" tooltipsText="Согласован">
                                                    <div className="flex items-center flex-col">
                                                      <svg className="inline-block -mt-1 ml-1.5" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M11.225 11.8199C11.225 12.0699 11.025 12.2699 10.775 12.2699H1.575C1.325 12.2699 1.125 12.0699 1.125 11.8199V2.61992C1.125 2.36992 1.325 2.16992 1.575 2.16992H9.925L10.925 1.04492C10.875 1.04492 10.85 1.04492 10.8 1.04492H1.575C0.725 1.04492 0 1.74492 0 2.61992V11.8449C0 12.7199 0.7 13.4199 1.575 13.4199H10.8C11.65 13.4199 12.375 12.7199 12.375 11.8449V2.84492L11.25 4.09492V11.8199H11.225Z" fill="#22AD5C"/>
                                                        <path d="M13.2501 0.144272C13.0251 -0.0557281 12.6751 -0.0557281 12.4501 0.194272L11.5251 1.21927L10.6751 2.16927L5.90014 7.51927L3.52514 5.34427C3.30014 5.14427 2.95014 5.14427 2.72514 5.36927C2.52514 5.59427 2.52514 5.94427 2.75014 6.16927L5.55014 8.71927C5.65014 8.81927 5.80014 8.86927 5.92514 8.86927H5.95014C6.10014 8.86927 6.25014 8.79427 6.35014 8.69427L11.2251 3.24427L12.2501 2.09427L13.3001 0.919272C13.5001 0.694272 13.5001 0.344272 13.2501 0.144272Z" fill="#22AD5C"/>
                                                      </svg>
                                                    </div>
                                                  </TooltipItem>
                                                </span>
                                                <span
                                                  className="text-sm text-[#637381]"
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      users[approver.get_email()] &&
                                                      users[approver.get_email()][
                                                      "jobTitle"
                                                      ],
                                                    }}
                                                />
                                              </div>
                                            </div>
                                          ))}
                                        </>
                                      )}
                                      {history.ChangeRights && history.Approvers && history.Approvers.length &&
                                        <TooltipItem position="top-left" className="w-max" tooltipsReactNode={
                                          <div className="flex flex-col gap-2">
                                            {[...[history.ChangeRights], ...history.Approvers].map((approver: any) => (
                                              <div className="flex items-center gap-2 relative">
                                                {users[approver.get_email()] && users[approver.get_email()].avatar && <img className="w-6 h-6 rounded-full max-sm:h-6 max-sm:w-6" src={users[approver.get_email()].avatar} /> || <div className="flex items-center justify-center w-6 h-6 rounded-full max-sm:h-6 max-sm:w-6 bg-darkblue">
                                                  <span className="font-medium text-[12px] max-sm:text-[10px] text-white select-none">{users[approver.get_email()] && users[approver.get_email()].shortName}</span>
                                                </div>}
                                                <div className="flex flex-col justify-center items-start">
                                                  <span className="text-sm text-[#111928]">{users[approver.get_email()] && users[approver.get_email()].displayName}</span>
                                                </div>
                                                {history.Approvers.some((prevApprover: any) => prevApprover.get_email() === approver.get_email()) && <div className="bg-white/[.75] absolute w-full h-full"></div>}
                                              </div>
                                            ))}
                                          </div>
                                        } tooltipsText="">
                                          <div className="flex items-center flex-col">
                                            <ArrowDown />
                                          </div>
                                        </TooltipItem>
                                      }
                                    </>
                                  )) ||
                                  (history.Denied && (
                                    <>
                                      {history.MultiApproved && history.MultiApproved.map((approver: any) => (
                                        <div className="flex flex-row gap-2">
                                          <UserAvatar
                                            avatar={
                                              users[approver.get_email()] &&
                                              users[approver.get_email()].avatar
                                            }
                                            shortName={
                                              users[approver.get_email()] &&
                                              users[approver.get_email()]
                                                .displayName &&
                                              users[
                                                approver.get_email()
                                              ].displayName.split(" ")[0][0] +
                                              users[
                                                approver.get_email()
                                              ].displayName.split(" ")[1][0]
                                            }
                                            displayName={
                                              users[approver.get_email()] &&
                                              users[approver.get_email()].displayName
                                            }
                                            email={approver.get_email()}
                                          />
                                          <div className="flex flex-col justify-center items-start">
                                            <span className="text-sm text-[#111928]">
                                              {users[approver.get_email()] &&
                                              users[approver.get_email()]
                                                .displayName}
                                              <TooltipItem position="top-center" className="w-max" tooltipsText="Согласован">
                                                <div className="flex items-center flex-col">
                                                  <svg className="inline-block -mt-1 ml-1.5" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11.225 11.8199C11.225 12.0699 11.025 12.2699 10.775 12.2699H1.575C1.325 12.2699 1.125 12.0699 1.125 11.8199V2.61992C1.125 2.36992 1.325 2.16992 1.575 2.16992H9.925L10.925 1.04492C10.875 1.04492 10.85 1.04492 10.8 1.04492H1.575C0.725 1.04492 0 1.74492 0 2.61992V11.8449C0 12.7199 0.7 13.4199 1.575 13.4199H10.8C11.65 13.4199 12.375 12.7199 12.375 11.8449V2.84492L11.25 4.09492V11.8199H11.225Z" fill="#22AD5C"/>
                                                    <path d="M13.2501 0.144272C13.0251 -0.0557281 12.6751 -0.0557281 12.4501 0.194272L11.5251 1.21927L10.6751 2.16927L5.90014 7.51927L3.52514 5.34427C3.30014 5.14427 2.95014 5.14427 2.72514 5.36927C2.52514 5.59427 2.52514 5.94427 2.75014 6.16927L5.55014 8.71927C5.65014 8.81927 5.80014 8.86927 5.92514 8.86927H5.95014C6.10014 8.86927 6.25014 8.79427 6.35014 8.69427L11.2251 3.24427L12.2501 2.09427L13.3001 0.919272C13.5001 0.694272 13.5001 0.344272 13.2501 0.144272Z" fill="#22AD5C"/>
                                                  </svg>
                                                </div>
                                              </TooltipItem>
                                            </span>
                                            <span
                                              className="text-sm text-[#637381]"
                                              dangerouslySetInnerHTML={{
                                              __html:
                                                users[approver.get_email()] &&
                                                users[approver.get_email()][
                                                "jobTitle"
                                                ],
                                              }}
                                            />
                                          </div>
                                        </div>
                                      ))}
                                      <div className="flex flex-row align-center gap-2">
                                        <UserAvatar
                                          avatar={
                                            users[history.Denied.get_email()] &&
                                            users[history.Denied.get_email()].avatar
                                          }
                                          shortName={
                                            users[history.Denied.get_email()] &&
                                            users[history.Denied.get_email()]
                                              .displayName &&
                                            users[
                                              history.Denied.get_email()
                                            ].displayName.split(" ")[0][0] +
                                            users[
                                              history.Denied.get_email()
                                            ].displayName.split(" ")[1][0]
                                          }
                                          displayName={
                                            users[history.Denied.get_email()] &&
                                            users[history.Denied.get_email()].displayName
                                          }
                                          email={history.Denied.get_email()}
                                        />
                                        <div className="flex flex-row justify-left items-start">
                                          <span className="text-sm text-[#111928]">
                                            {users[history.Denied.get_email()] &&
                                              users[history.Denied.get_email()]
                                                .displayName}
                                            {history.MultiApprove && (
                                              <TooltipItem position="top-center" className="w-max" tooltipsText="Отклонен">
                                                <div className="flex items-center flex-col">
                                                  <svg className="inline-block ml-1.5" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M7.55 0C3.375 0 0 3.375 0 7.55C0 11.725 3.375 15.125 7.55 15.125C11.725 15.125 15.125 11.725 15.125 7.55C15.125 3.375 11.725 0 7.55 0ZM7.55 14C4 14 1.125 11.1 1.125 7.55C1.125 4 4 1.125 7.55 1.125C11.1 1.125 14 4.025 14 7.575C14 11.1 11.1 14 7.55 14Z" fill="#BA0C2F"/>
                                                    <path d="M9.85039 5.22539C9.62539 5.00039 9.27539 5.00039 9.05039 5.22539L7.55039 6.75039L6.02539 5.22539C5.80039 5.00039 5.45039 5.00039 5.22539 5.22539C5.00039 5.45039 5.00039 5.80039 5.22539 6.02539L6.75039 7.55039L5.22539 9.07539C5.00039 9.30039 5.00039 9.65039 5.22539 9.87539C5.32539 9.97539 5.47539 10.0504 5.62539 10.0504C5.77539 10.0504 5.92539 10.0004 6.02539 9.87539L7.55039 8.35039L9.07539 9.87539C9.17539 9.97539 9.32539 10.0504 9.47539 10.0504C9.62539 10.0504 9.77539 10.0004 9.87539 9.87539C10.1004 9.65039 10.1004 9.30039 9.87539 9.07539L8.35039 7.55039L9.87539 6.02539C10.0754 5.80039 10.0754 5.45039 9.85039 5.22539Z" fill="#BA0C2F"/>
                                                  </svg>
                                                </div>
                                              </TooltipItem>
                                            )}
                                          </span>
                                          <span
                                            className="text-sm text-[#637381]"
                                            dangerouslySetInnerHTML={{
                                              __html:
                                                users[history.Denied.get_email()] &&
                                                users[history.Denied.get_email()][
                                                "jobTitle"
                                                ],
                                            }}
                                          />
                                        </div>
                                        {history.ChangeRights && history.Approvers && history.Approvers.length &&
                                          <TooltipItem position="top-left" className="w-max" tooltipsReactNode={
                                            <div className="flex flex-col gap-2">
                                              {[...[history.ChangeRights], ...history.Approvers].map((approver: any) => (
                                                <div className="flex items-center gap-2 relative">
                                                  {users[approver.get_email()] && users[approver.get_email()].avatar && <img className="w-6 h-6 rounded-full max-sm:h-6 max-sm:w-6" src={users[approver.get_email()].avatar} /> || <div className="flex items-center justify-center w-6 h-6 rounded-full max-sm:h-6 max-sm:w-6 bg-darkblue">
                                                    <span className="font-medium text-[12px] max-sm:text-[10px] text-white select-none">{users[approver.get_email()] && users[approver.get_email()].shortName}</span>
                                                  </div>}
                                                  <div className="flex flex-col justify-center items-start">
                                                    <span className="text-sm text-[#111928]">{users[approver.get_email()] && users[approver.get_email()].displayName}</span>
                                                  </div>
                                                  {history.Approvers.some((prevApprover: any) => prevApprover.get_email() === approver.get_email()) && <div className="bg-white/[.75] absolute w-full h-full"></div>}
                                                </div>
                                              ))}
                                            </div>
                                          } tooltipsText="">
                                            <div className="flex items-center flex-col">
                                              <ArrowDown />
                                            </div>
                                          </TooltipItem>
                                        }
                                      </div>
                                    </>
                                  )) || (
                                    <>
                                      {history.Approvers.map((approver: any) => (
                                        <>
                                          <UserAvatar
                                            avatar={
                                              users[approver.get_email()] &&
                                              users[approver.get_email()].avatar
                                            }
                                            shortName={
                                              users[approver.get_email()] &&
                                              users[approver.get_email()]
                                                .displayName &&
                                              users[
                                                approver.get_email()
                                              ].displayName.split(" ")[0][0] +
                                              users[
                                                approver.get_email()
                                              ].displayName.split(" ")[1][0]
                                            }
                                            displayName={
                                              users[approver.get_email()] &&
                                              users[approver.get_email()].displayName
                                            }
                                            email={approver.get_email()}
                                          />
                                          <div className="flex flex-col justify-center items-start">
                                            <span className="text-sm text-[#111928]">
                                              {users[approver.get_email()] &&
                                                users[approver.get_email()]
                                                  .displayName}
                                            </span>
                                            <span
                                              className="text-sm text-[#637381]"
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  users[approver.get_email()] &&
                                                  users[approver.get_email()][
                                                  "jobTitle"
                                                  ],
                                              }}
                                            />
                                          </div>
                                        </>
                                      ))}
                                    </>
                                  )}
                              </div>
                              {history.Comment && (
                                <div className="flex items-center gap-2">
                                  <Comment />
                                  <span className="text-sm text-[#111928]">
                                    {history.Comment}
                                  </span>
                                </div>
                              )}
                              {history.JSONChangesFields &&
                                <HistoryFieldChanges
                                  versionView={versionView}
                                  documentCardID={documentCardID}
                                  JsomHistoryFields={history.JSONChangesFields}
                                />
                              }
                            </div>
                          </div>
                        ))}
                    {renderHistoryData.length > 0 &&
                      renderHistoryData
                        .filter((history: any) =>
                          history.Statuses.some(
                            (item: any) => item.get_lookupId() === docStatuses.waitApproval
                          )
                        )
                        .map((history: any) => (
                          <div className="history_block flex w-full my-6 -ml-1.5">
                            <div className="pt-5 flex items-start w-2/12 z-10">
                              <div className="w-2.5 h-2.5 bg-[#DFE4EA] rounded-full mr-4 mt-1.5"></div>
                              <span className="text-[#637381] text-sm">
                                Ожидается
                              </span>
                            </div>
                            <div className="flex p-5 flex-col justify-center items-start gap-5 flex-[1_0%_0%] w-9/12 rounded-lg border border-solid border-[#DFE4EA]">
                              <div className="w-full items-center flex justify-between">
                                <span className="text-sm flex items-center">
                                  {(history.ChangeRights && history.Title && history.Title) ||
                                    history.ApprovalGroup && history.ApprovalGroup.get_lookupValue && history.ApprovalGroup.get_lookupValue()}
                                  {history.MultiApprove && (
                                    <>
                                      {(() => {
                                        const total = history.Approvers?.length || 0;
                                        const approved = history.MultiApproved?.length || 0;
                                        const remaining = total - approved;
                                        if (remaining === 0) return " | Все согласующие выполнили согласование";
                                        return (
                                          <div className="">
                                            &nbsp;| Ожидает согласования еще {remaining} из {total} согласующих&nbsp;
                                            <TooltipItem
                                              position="top-left"
                                              className="w-max"
                                              tooltipsReactNode={
                                              <div className="flex flex-col gap-2">
                                                {history.Approvers.map((approver: any) => {

                                                  const approverEmail = approver.get_email();
                                                  // Проверяем, согласовал ли этот пользователь
                                                  const isApproved = history.MultiApproved?.some(
                                                    (approvedUser: any) => approvedUser.get_email?.() === approverEmail
                                                  );

                                                  return (
                                                    <div className="flex items-center gap-2 relative" key={approverEmail}>
                                                      {users[approverEmail] && users[approverEmail].avatar ? (
                                                        <img
                                                          className="w-6 h-6 rounded-full max-sm:h-6 max-sm:w-6"
                                                          src={users[approverEmail].avatar}
                                                        />
                                                      ) : (
                                                        <div className="flex items-center justify-center w-6 h-6 rounded-full max-sm:h-6 max-sm:w-6 bg-darkblue">
                                                          <span className="font-medium text-[12px] max-sm:text-[10px] text-white select-none">
                                                            {users[approverEmail] && users[approverEmail].shortName}
                                                          </span>
                                                        </div>
                                                      )}
                                                      <div className="flex flex-col justify-center items-start">
                                                        <span className="text-sm text-[#111928]">
                                                          {users[approverEmail] && users[approverEmail].displayName}
                                                        </span>
                                                      </div>
                                                      {/* Затемняем тех, кто НЕ согласовал */}
                                                      {!isApproved && (
                                                        <div class="bg-white/[.75] absolute w-full h-full" />
                                                      )}
                                                    </div>
                                                  );
                                                })}
                                              </div>
                                            }
                                              tooltipsText=""
                                            >
                                              <div className="flex items-center flex-col">
                                                <ArrowDown />
                                              </div>
                                            </TooltipItem>
                                          </div>
                                        );
                                      })()}
                                    </>
                                  )}
                                </span>
                                <HistoryStatuses statuses={history.Statuses} />
                              </div>
                              <div className="flex items-center gap-2 w-full">
                                {(!history.Approved &&
                                  !history.Denied &&
                                  history.ApprovalGroup &&
                                  currentApprovers[history.ApprovalGroup.get_lookupId()] &&
                                  edit &&
                                  history.Statuses.filter(
                                    (status: any) =>
                                      status.get_lookupId() === docStatuses.waitApproval
                                  ).length === 1 && (
                                    <>
                                      {history.Approvers && history.Approvers.length > 0 && (
                                        <>
                                          {(() => {
                                            let notApprovedPeople = [...history.Approvers];
                                            let approvedPeople = [];
                                            if (history.MultiApproved && history.MultiApproved.length > 0) {
                                              const multiIds = new Set(
                                                history.MultiApproved.map(m => m.get_lookupId())
                                              );
                                              notApprovedPeople = history.Approvers.filter(
                                                person => !multiIds.has(person.get_lookupId())
                                              );
                                              approvedPeople = history.Approvers.filter(
                                                person => multiIds.has(person.get_lookupId())
                                              );
                                            }
                                            const notApprovedEmails = new Set(
                                              notApprovedPeople.map(person => person.get_email())
                                            );
                                            const approvedEmails = new Set(
                                              approvedPeople.map(person => person.get_email())
                                            );
                                            const currentData = currentApprovers[history.ApprovalGroup.get_lookupId()]["field"];
                                            const filteredValue = currentData.value.filter(
                                              item => notApprovedEmails.has(item.email)
                                            );
                                            const filteredOptions = currentData.dataField.options.filter(
                                              item => !approvedEmails.has(item.email)
                                            );
                                            const filteredDataField = {
                                              ...currentData.dataField,
                                              options: filteredOptions
                                            };
                                            return (
                                              <PeoplePicker
                                                dataField={
                                                  //currentApprovers[history.ApprovalGroup.get_lookupId()]["field"]["dataField"]
                                                  filteredDataField
                                                }
                                                onChange={
                                                  currentApprovers[history.ApprovalGroup.get_lookupId()]["field"]["onChange"]
                                                }
                                                value={filteredValue}
                                                type={
                                                  currentApprovers[history.ApprovalGroup.get_lookupId()]["field"]["type"]
                                                }
                                              />
                                            );
                                          })()}
                                        </>
                                      )}
                                    </>
                                  )) ||
                                  (history.Approved && (
                                    <>
                                      <UserAvatar
                                        avatar={
                                          users[history.Approved.get_email()] &&
                                          users[history.Approved.get_email()].avatar
                                        }
                                        shortName={
                                          users[history.Approved.get_email()] &&
                                          users[history.Approved.get_email()]
                                            .displayName &&
                                          users[
                                            history.Approved.get_email()
                                          ].displayName.split(" ")[0][0] +
                                          users[
                                            history.Approved.get_email()
                                          ].displayName.split(" ")[1][0]
                                        }
                                        displayName={
                                          users[history.Approved.get_email()] &&
                                          users[history.Approved.get_email()]
                                            .displayName
                                        }
                                        email={history.Approved.get_email()}
                                      />
                                      <div className="flex flex-col justify-center items-start">
                                        <span className="text-sm text-[#111928]">
                                          {users[history.Approved.get_email()] &&
                                            users[history.Approved.get_email()]
                                              .displayName}
                                        </span>
                                        <span
                                          className="text-sm text-[#637381]"
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              users[history.Approved.get_email()] &&
                                              users[history.Approved.get_email()][
                                              "jobTitle"
                                              ],
                                          }}
                                        />
                                      </div>
                                      {history.ChangeRights && history.Approvers && history.Approvers.length &&
                                        <TooltipItem position="top-left" className="w-max" tooltipsReactNode={
                                          <div className="flex flex-col gap-2">
                                            {[...[history.ChangeRights], ...history.Approvers].map((approver: any) => (
                                              <div className="flex items-center gap-2 relative">
                                                {users[approver.get_email()] && users[approver.get_email()].avatar && <img className="w-6 h-6 rounded-full max-sm:h-6 max-sm:w-6" src={users[approver.get_email()].avatar} /> || <div className="flex items-center justify-center w-6 h-6 rounded-full max-sm:h-6 max-sm:w-6 bg-darkblue">
                                                  <span className="font-medium text-[12px] max-sm:text-[10px] text-white select-none">{users[approver.get_email()] && users[approver.get_email()].shortName}</span>
                                                </div>}
                                                <div className="flex flex-col justify-center items-start">
                                                  <span className="text-sm text-[#111928]">{users[approver.get_email()] && users[approver.get_email()].displayName}</span>
                                                </div>
                                                {history.Approvers.some((prevApprover: any) => prevApprover.get_email() === approver.get_email()) && <div className="bg-white/[.75] absolute w-full h-full"></div>}
                                              </div>
                                            ))}
                                          </div>
                                        } tooltipsText="">
                                          <div className="flex items-center flex-col">
                                            <ArrowDown />
                                          </div>
                                        </TooltipItem>
                                      }
                                    </>
                                  )) ||
                                  (history.Denied && (
                                    <>
                                      <UserAvatar
                                        avatar={
                                          users[history.Denied.get_email()] &&
                                          users[history.Denied.get_email()].avatar
                                        }
                                        shortName={
                                          users[history.Denied.get_email()] &&
                                          users[history.Denied.get_email()]
                                            .displayName &&
                                          users[
                                            history.Denied.get_email()
                                          ].displayName.split(" ")[0][0] +
                                          users[
                                            history.Denied.get_email()
                                          ].displayName.split(" ")[1][0]
                                        }
                                        displayName={
                                          users[history.Denied.get_email()] &&
                                          users[history.Denied.get_email()].displayName
                                        }
                                        email={history.Denied.get_email()}
                                      />
                                      <div className="flex flex-col justify-center items-start">
                                        <span className="text-sm text-[#111928]">
                                          {users[history.Denied.get_email()] &&
                                            users[history.Denied.get_email()]
                                              .displayName}
                                        </span>
                                        <span
                                          className="text-sm text-[#637381]"
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              users[history.Denied.get_email()] &&
                                              users[history.Denied.get_email()][
                                              "jobTitle"
                                              ],
                                          }}
                                        />
                                      </div>
                                      {history.ChangeRights && history.Approvers && history.Approvers.length &&
                                        <TooltipItem position="top-left" className="w-max" tooltipsReactNode={
                                          <div className="flex flex-col gap-2">
                                            {[...[history.ChangeRights], ...history.Approvers].map((approver: any) => (
                                              <div className="flex items-center gap-2 relative">
                                                {users[approver.get_email()] && users[approver.get_email()].avatar && <img className="w-6 h-6 rounded-full max-sm:h-6 max-sm:w-6" src={users[approver.get_email()].avatar} /> || <div className="flex items-center justify-center w-6 h-6 rounded-full max-sm:h-6 max-sm:w-6 bg-darkblue">
                                                  <span className="font-medium text-[12px] max-sm:text-[10px] text-white select-none">{users[approver.get_email()] && users[approver.get_email()].displayName && users[approver.get_email()].displayName.split(' ')[0][0] + users[approver.get_email()].displayName.split(' ')[1][0]}</span>
                                                </div>}
                                                <div className="flex flex-col justify-center items-start">
                                                  <span className="text-sm text-[#111928]">${users[approver.get_email()] && users[approver.get_email()].displayName}</span>
                                                </div>
                                                {history.Approvers.some((prevApprover: any) => prevApprover.get_email() === approver.get_email()) && <div className="bg-white/[.75] absolute w-full h-full"></div>}
                                              </div>
                                            ))}
                                          </div>
                                        } tooltipsText="">
                                          <div className="flex items-center flex-col">
                                            <ArrowDown />
                                          </div>
                                        </TooltipItem>
                                      }
                                    </>
                                  )) || (
                                    <>
                                      {history.Approvers.map((approver: any) => (
                                        <>
                                          <UserAvatar
                                            avatar={
                                              users[approver.get_email()] &&
                                              users[approver.get_email()].avatar
                                            }
                                            shortName={
                                              users[approver.get_email()] &&
                                              users[approver.get_email()]
                                                .displayName &&
                                              users[
                                                approver.get_email()
                                              ].displayName.split(" ")[0][0] +
                                              users[
                                                approver.get_email()
                                              ].displayName.split(" ")[1][0]
                                            }
                                            displayName={
                                              users[approver.get_email()] &&
                                              users[approver.get_email()].displayName
                                            }
                                            email={approver.get_email()}
                                          />
                                          <div className="flex flex-col justify-center items-start">
                                            <span className="text-sm text-[#111928]">
                                              {users[approver.get_email()] &&
                                                users[approver.get_email()]
                                                  .displayName}
                                            </span>
                                            <span
                                              className="text-sm text-[#637381]"
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  users[approver.get_email()] &&
                                                  users[approver.get_email()][
                                                  "jobTitle"
                                                  ],
                                              }}
                                            />
                                          </div>
                                        </>
                                      ))}
                                    </>
                                  )}
                              </div>
                              {history.Comment && (
                                <div className="flex items-center gap-2">
                                  <Comment />
                                  <span className="text-sm text-[#111928]">
                                    {history.Comment}
                                  </span>
                                </div>
                              )}
                              {history.JSONChangesFields &&
                                <HistoryFieldChanges
                                  versionView={versionView}
                                  documentCardID={documentCardID}
                                  JsomHistoryFields={history.JSONChangesFields}
                                />
                              }
                            </div>
                          </div>
                        ))}
                  </>
                )}
            </div>
            {showSaveBtns && (
              <div className="w-full flex justify-between">
                <Button
                  classBg="btn-white"
                  shadow={true}
                  text="Отменить изменения"
                  customFunction={resetDefaultValuesHandle}
                />

                <Button
                  classBg="btn-dark"
                  text="Сохранить изменения"
                  customFunction={saveNewApproversHandle}
                />
              </div>
            )}
          </>
        )}
    </div>
  );
};

export default ApproversCard;
